import remoteJs from '../../bundles/modules/remote-js'

const settingsApp = () => {
  remoteJs()
  return {
    App: {
      settings: [
        {
          label: 'Js Console aktivieren',
          valueKey: 'dlabConsoleTest',
          type: 'switch',
        },
      ],
    },
  }
}
export default settingsApp
